import React from "react";
import Button, { Icons } from "../../components/buttons/Button";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { CREATE_XSSI_CONNECTION_TRANSLATIONS } from "../../translations/util";

export interface IProps {
  onCancel: () => void;
  onDelete: () => void;
  loading?: boolean;
}

const DeleteConfirmation = ({
  onCancel,
  onDelete,
  loading = false,
}: IProps) => {
  return (
    <div className="data-card delete-section">
      <div className="cds--modal-header">
        <h4 className="flex" data-cy="deleteRange-modalHeader">
          <span className="modal-icon">
            <DeleteIcon />
          </span>
          {CREATE_XSSI_CONNECTION_TRANSLATIONS.ranges.deleteModal.title}
        </h4>
      </div>

      <div className="cds--modal-content cds--modal-content--with-form">
        <p
          className="bx--modal-content__text bx--modal-content__regular-content text-left"
          data-cy="deleteRange-modalDescription"
        >
          {CREATE_XSSI_CONNECTION_TRANSLATIONS.ranges.deleteModal.description}
        </p>
      </div>

      <div className="footer">
        <Button
          className="mr-2"
          kind="tertiary"
          type="button"
          disabled={false}
          label={CREATE_XSSI_CONNECTION_TRANSLATIONS.ranges.deleteModal.cancel}
          onClick={onCancel}
          dataCy="cancelDeleteRange-"
        />

        <Button
          kind="danger"
          className=""
          type="button"
          disabled={false}
          loading={loading}
          icon={Icons.Delete}
          onClick={onDelete}
          label={CREATE_XSSI_CONNECTION_TRANSLATIONS.ranges.deleteModal.delete}
          dataCy="yesDeleteRange-"
        />
      </div>
    </div>
  );
};

export default DeleteConfirmation;
